import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Locks the app to the `/kiosk` route tree when launched as a PWA. Once the
 * H4Community kiosk has been installed and opened in standalone / fullscreen
 * mode, the device should behave like a single-purpose appliance: typing other
 * URLs, deep links to login, or the SPA's default redirects must not pop the
 * user into the main web app.
 *
 * Wired as `canMatch` on every non-kiosk top-level route. In a regular browser
 * tab the guard is a no-op — all routes load normally.
 */
export const kioskPwaScopeGuard: CanMatchFn = () => {
  if (typeof window === 'undefined') return true;

  const standalone =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.matchMedia?.('(display-mode: fullscreen)').matches ||
    // iOS Safari uses the legacy navigator.standalone flag instead of the
    // display-mode media query.
    !!(navigator as { standalone?: boolean }).standalone;

  if (!standalone) return true;

  // Redirect to /kiosk so the route tree lands on the kiosk shell instead of
  // the route the guard rejected.
  return inject(Router).parseUrl('/kiosk');
};
